module.exports = __webpack_public_path__ + "img/roundabout-right.65a72b2d.svg";